
class ServiceQuestionSystem{
   constructor(){
      /** @type { ServiceQuestion[]] } */
      this.elements = [];
      
      /** @type { ServiceQuestion[]] } */
      this.currentChain = [];

      // TODO now only one can be there per page.
      // This is most likely perfectly fine but still
      this.insertTarget = document.querySelector("[data-service-question-insert-target]");
   }

   init(){
      if(this.elements.length === 0) return;
      let first = this.elements[0];

      first.insert(this.insertTarget);
      this.currentChain.push(first);
   }

   /**
    * @param {ServiceQuestion} question 
    */
   append(question){
      question.insert(this.insertTarget);
      this.currentChain.push(question);
      
      this.scrollToLast();
   }

   scrollToLast(){
      let question = this.currentChain[this.currentChain.length - 1];

      let height = question.element.offsetHeight;
      let windowHeight = window.innerHeight;

      let offset = (windowHeight - height) / 2;

      if(offset < 100) offset = 100;
      if(offset > 400) offset = 400;

      window.scrollTo({
         top: question.element.offsetTop - offset,
         left: 0,
         behavior: 'smooth'
      });
   }

   /**
    * @param {ServiceQuestion} question 
    */
   returnTo(question){
      let index = this.getIndexInChain(question);

      this.returnToIndex(index);
   }

   /**
    * @param {number} index 
    */
   returnToIndex(index){
      if(index < 0) return;

      index += 1;

      for(var i = index; i < this.currentChain.length; i++){
         this.currentChain[i].remove();
      }

      // I did not know this was possible and its the ugliest shit
      // I've ever seen and at the same time I marvel at its 
      // utility
      this.currentChain.length = index;

      this.currentChain[index - 1].deactivate();
   }

   /**
    * @param {number} id 
    * @return {ServiceQuestion} 
    */
   findServiceQuestionById(id){
      return this.elements.find(element => element.id === id);
   }

   /**
    * @param {ServiceQuestion} element 
    */
   getIndexInChain(element){
      return this.currentChain.indexOf(element);
   }
}
class ServiceQuestion {
   /**
    * @param {ServiceQuestionSystem} system
    * @param {HTMLElement} element
    */
   constructor(system, element){
      this.id = parseInt(element.getAttribute("data-service-question-id"));

      /** @type { HTMLElement[] } */
      this.questions = element.querySelectorAll("[data-service-question-option]");

      this.backButton = element.querySelector(".back");

      this.element = element;
      this.system = system;
      this.enabled = false;

      this.remove();

      // Question behaviour
      this.questions.forEach(question => {
         /** @type { number|undefined } */
         let target = parseInt(question.getAttribute("data-service-question-target-id"));
         
         question.addEventListener("click", ()=>{
            
            // Go back to this question first. This does nothing if we 
            // are the final question, but if we aren't, it should remove the 
            // previous answers
            this.system.returnTo(this);

            this.activate(question);

            if(target !== undefined){
               this.system.append(this.system.findServiceQuestionById(target));
            }
         });

         window.addEventListener("load", ()=>{
            if(question.classList.contains('prefill-active')) {
               this.activate(question);

               if(target !== undefined){
                  this.system.append(this.system.findServiceQuestionById(target));
               }
            }
         });
      });

      // Back button!
      if(this.backButton){
         this.backButton.addEventListener("click", () => {
            let index = this.system.getIndexInChain(this);

            this.system.returnToIndex(index - 1);
            this.system.scrollToLast();
         });
      }
   }

   /**
    * @param {HTMLElement} target 
    */
   insert(target){
      document.body.insertBefore(this.element, target);

      this.enabled = true;

      this.deactivate();

      // This is to make sure it calculates opacity first before adding 
      // the visible class (this triggering the animation).
      // It aint pretty but what can you expect :)

      this.element.offsetHeight;
      this.element.classList.add("visible");
   }

   remove(){
      this.enabled = false;
      this.element.classList.remove("visible");

      setTimeout(() => {
         if(!this.enabled){
            document.body.removeChild(this.element);
         }
      }, 400);
   }

   deactivate(){
      this.questions.forEach(question => question.classList.remove("inactive"));
   }

   activate(option){
      this.questions.forEach(question => question.classList.toggle("inactive", question !== option));
   }
}

export function initServiceQuestions(){
   let questions = document.querySelectorAll("[data-service-question-id]");

   if(questions.length == 0) return;

   let system = new ServiceQuestionSystem();

   // Insert them all
   questions.forEach(question => {
      let service = new ServiceQuestion(system, question);

      system.elements.push(service);
   });

   system.init();
}



/**
 * @param {number} id 
 * @returns {HTMLElement|null}
 */
function findServiceQuestionById(id){
   return document.querySelector(`[data-service-question-id=\"${id}\"]`);
}

export function initServiceQuestions2(){
   /** @var {HTMLElement[]} */
   let questions = document.querySelectorAll("[data-service-question-target-id]");

   questions.forEach(element => {
      let id = element.getAttribute("data-service-question-target-id");
      let target = findServiceQuestionById(id);

      /** @var HTMLElement[] */
      let siblings = element.parentElement.querySelectorAll(".option");

      // TODO complicated logic :)
      element.addEventListener("click", ()=>{
         target.classList.toggle("visible");

         siblings.forEach(s => {
            s.classList.toggle("inactive", s !== element);
         })
      });
   });
}